import React from 'react';
import Layout from '../components/layout';
import Logo from '../components/logo';
import RoundResults from '../components/round-results';
import Footer from '../components/footer';

function ResultRound(props) {
  let layoutClass = props.rounds[props.round - 1].correct > 2 ? 'bg-blue' : 'bg-red';
  return (
    <Layout bgClass={layoutClass}>
      <div className="results">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="results-header">
                <Logo campaign={props.campaign.name} textAlign="center" />
              </div>
            </div>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-md-5">
              <RoundResults 
                username={props.username}
                currentRound={props.round}
                challengePoints={props.challengePoints}
                rounds={props.rounds}
                toNextRound={props.toNextRound}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
export default ResultRound;